import React, { useState, useEffect } from 'react';
import HeaderOne from "../components/HeaderTwo";
import BottomFooter from "../components/BottomFooter";

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            console.log('Fetching testimonials from API...');
            // UPDATED API URL
            const response = await fetch(`${process.env.REACT_APP_API_URL}/testimonials/`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            
            console.log('Response status:', response.status);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch testimonials: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('Fetched testimonials:', data);
            
            setTestimonials(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
            console.error('Error fetching testimonials:', err);
        }
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, index) => (
            <span key={index} style={{ opacity: index < rating ? 1 : 0.3 }}>
                ⭐
            </span>
        ));
    };

    const renderTestimonialCard = (testimonial) => (
        <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-header">
                <div className="avatar">{testimonial.avatar_initials}</div>
                <div className="testimonial-info">
                    <h3 className="customer-name">{testimonial.name}</h3>
                    <p className="time-ago">{testimonial.time_ago}</p>
                </div>
            </div>
            <div className="testimonial-body">
                <div className="stars">
                    {renderStars(testimonial.rating)}
                </div>
                <p className="review-text">{testimonial.review}</p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <>
                <HeaderOne />
                <div className="testimonials-container">
                    <section className="testimonials-hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Customer Testimonials</h1>
                            <p className="hero-subtitle">Loading testimonials...</p>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    if (error) {
        return (
            <>
                <HeaderOne />
                <div className="testimonials-container">
                    <section className="testimonials-hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Customer Testimonials</h1>
                            <p className="hero-subtitle" style={{ color: 'red' }}>
                                Error loading testimonials: {error}
                            </p>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    if (testimonials.length === 0) {
        return (
            <>
                <HeaderOne />
                <div className="testimonials-container">
                    <section className="testimonials-hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Customer Testimonials</h1>
                            <p className="hero-subtitle">
                                No testimonials available at the moment.
                            </p>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    const rows = [];
    for (let i = 0; i < testimonials.length; i += 2) {
        rows.push(testimonials.slice(i, i + 2));
    }

    return (
        <>
            <HeaderOne />
            <div className="testimonials-container">
                <section className="testimonials-hero-section">
                    <div className="hero-content">
                        <h1 className="hero-title">Customer Testimonials</h1>
                        <p className="hero-subtitle">
                            Here is what some of our customers have had to say about our printing services
                        </p>
                    </div>
                </section>

                <section className="testimonials-main-content">
                    <div className="content-wrapper">
                        {rows.map((row, rowIndex) => (
                            <div key={rowIndex} className="testimonials-row">
                                {row.map(testimonial => renderTestimonialCard(testimonial))}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
            <BottomFooter />
        </>
    );
};

export default Testimonials;
